/*
 * Spinder breadcrumb-trail
 * ------------------------
 * Houdt de route bij die de bezoeker echt loopt (in sessionStorage) en
 * herschrijft op de productpagina de breadcrumb naar exact dat pad. Bijv.:
 *   Home › Producten › Kapstokken › Wandkapstokken › KEEPER Wandkapstok
 *   Home › Ruimtes › Hal › KEEPER Wandkapstok
 *
 * Op collectie-/hubpagina's wordt de trail alleen bijgewerkt (de server-
 * breadcrumd blijft daar staan). Komt de bezoeker rechtstreeks op een product
 * (geen route), dan blijft de server-gerenderde breadcrumb (ruimte/categorie)
 * staan — zo is er altijd een geldig kruimelpad.
 */
(function () {
  'use strict';
  var KEY = 'spd_bc_trail';

  function read() { try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(a) { try { sessionStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {} }
  function path(u) { try { return (new URL(u, location.origin).pathname).replace(/\/+$/, '') || '/'; } catch (e) { return u; } }
  function samePath(a, b) { return path(a) === path(b); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var nodeEl = document.getElementById('spd-bc-node');
  if (!nodeEl) return;
  var node;
  try { node = JSON.parse(nodeEl.textContent); } catch (e) { return; }

  var trail = read();

  if (node.type === 'collection' || node.type === 'hub') {
    // Geen accumulatie over takken: zet de trail op de CANONIEKE keten van deze
    // pagina (room -> Ruimtes › ruimte, categorie -> Producten › categorie).
    // Zo verdwijnt een eerdere, niet-gerelateerde tak (bv. Producten › Kapstokken)
    // zodra je in een andere tak (Ruimtes › Hal) komt.
    if (node.chain && node.chain.length) {
      trail = node.chain.map(function (c) { return { url: c.url, label: c.label }; });
    } else {
      trail = [{ url: node.url, label: node.label }];
    }
    write(trail);
  } else if (node.type === 'product') {
    // Herschrijf als de bezoeker vanaf een pagina úit de trail kwam (niet alleen
    // de laatste): kom je bv. via Producten-hub terug op het product, dan wordt
    // de trail tot dat punt afgekapt. Referrer = het product zelf (herladen /
    // variantwissel) telt ook — de bezoeker heeft de route niet verlaten.
    var ref = document.referrer || '';
    var fromSelf = ref && samePath(ref, node.url);
    var cutIdx = -1;
    if (ref) {
      for (var i = trail.length - 1; i >= 0; i--) {
        if (samePath(ref, trail[i].url)) { cutIdx = i; break; }
      }
    }
    if (trail.length && fromSelf) {
      renderBreadcrumb(trail, node);
    } else if (cutIdx >= 0) {
      trail = trail.slice(0, cutIdx + 1);
      write(trail);
      renderBreadcrumb(trail, node);
    }
  }

  function renderBreadcrumb(trailItems, node) {
    var ol = document.querySelector('[data-spd-breadcrumb]');
    if (!ol) return;
    var items = [{ label: node.homeLabel || 'Home', url: node.homeUrl || '/', current: false }];
    trailItems.forEach(function (t) { items.push({ label: t.label, url: t.url, current: false }); });
    items.push({ label: node.label, url: node.url, current: true });

    var html = '';
    items.forEach(function (it, i) {
      var inner = it.current
        ? '<span itemprop="name" aria-current="page">' + esc(it.label) + '</span>'
        : '<a href="' + esc(it.url) + '" itemprop="item"><span itemprop="name">' + esc(it.label) + '</span></a>';
      html += '<li class="breadcrumb__item' + (it.current ? ' breadcrumb__item--current' : '') + '"'
            + ' itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">'
            + inner + '<meta itemprop="position" content="' + (i + 1) + '"></li>';
    });
    ol.innerHTML = html;
  }
})();
